var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('v-col',_vm._g(_vm._b({},'v-col',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('v-dialog',_vm._g(_vm._b({staticClass:"custom-dialog",attrs:{"fullscreen":"","persistent":""}},'v-dialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }